import React from "react";
import styles from "./WaysToStyleModalThumbnails.scss";
import classnamesBind from "classnames/bind";
import { StylingLookProductWithStockPrice } from "../../types/productTypes/stylingLookProduct";
import Image from "../image/Image";
import { getPrimaryImage } from "../../utils/product";

const classnames = classnamesBind.bind(styles);

interface WaysToStyleModalThumbnailsProps {
  products: StylingLookProductWithStockPrice[];
  selectedThumbnailIndex: number;
  onThumbnailSelect: (index: number) => void;
}

const WaysToStyleModalThumbnails: React.FC<WaysToStyleModalThumbnailsProps> = ({
  products,
  selectedThumbnailIndex,
  onThumbnailSelect,
}) => {
  return (
    <div
      className={styles.thumbnailCarousel}
      data-testid="waysToStyleModalThumbnailCarousel"
    >
      {products.map(
        (product: StylingLookProductWithStockPrice, index: number) => {
          const isSelected = index === selectedThumbnailIndex;
          return (
            <button
              className={classnames(styles.thumbnail, {
                [styles.selected]: isSelected,
              })}
              key={`${product.id}-${index}`}
              onClick={() => onThumbnailSelect(index)}
            >
              <Image
                url={getPrimaryImage(product.images)?.url}
                alternateText={product.name}
                type="thumbnail"
                width={56}
                additionalClasses=""
                loadingType="lazy"
                ariaHidden={false}
              />
            </button>
          );
        }
      )}
    </div>
  );
};

export default WaysToStyleModalThumbnails;
